<template>
  <div class="app">
    <router-view :key="$route.name + ($route.params.id || '')"></router-view>
  </div>
</template>

<script>
  export default {
    name: "App",
  };
</script>

<style scoped>
  .app {
    margin: 0;
    padding: 0;
    width: 100vw;
    height: 100vh;
    overflow: hidden;
  }
</style>